import useLanguageCode from '@alltrails/shared/hooks/useLanguageCode';
import useUser from '@alltrails/context/hooks/useUser';
import useFeatures from '@alltrails/features/hooks/useFeatures';

export default function useAdaChatbot(experimentEnabled = false): {
  isAdaReady: boolean;
  config: {
    handle: string | null;
    language: string;
  };
} {
  const features = useFeatures();
  const languageCode = useLanguageCode();
  const user = useUser();

  const isAdaReady = !!(experimentEnabled && features?.includes('ada_chatbot') && user);

  return {
    isAdaReady,
    config: {
      handle: process.env.NEXT_PUBLIC_ADA_HANDLE_GENERATIVE!,
      language: languageCode
    }
  };
}
